import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";
import "./index.css";

class ChartTimeDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //this is hard-coded for now. Replace it when the api is ready
      selectedChartTime: { id: "one_week", name: "One chart per week" },
      chartTimeList: [
        { id: "one_day", name: "One chart per day" },
        { id: "one_week", name: "One chart per week" },
        { id: "one_month", name: "One chart per month" }
      ]
    };
  }

  componentDidMount = () => {
    const { selectedChartTime } = this.state;
    this.props.change(selectedChartTime.id);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.reset !== nextProps.reset) {
      this.setState({
        selectedChartTime: ""
      });
      this.props.change("");
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedChartTime: selectedOption });
    if (selectedOption) {
      this.props.change(selectedOption.id);
    } else {
      this.props.change(null);
    }
  };

  render = () => {
    const { selectedChartTime, chartTimeList } = this.state;

    if (chartTimeList) {
      return (
        <div>
          <FormGroup controlId="formControlsSelect">
            <ControlLabel>Max time per chart</ControlLabel>
            <Select
              name="form-field-name"
              value={selectedChartTime}
              onChange={this.handleChange}
              valueKey="id"
              labelKey="name"
              options={chartTimeList}
            />
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    configList
  };
}

export default connect(mapStateToProps)(ChartTimeDropdown);



// WEBPACK FOOTER //
// ./src/_components/ChartTimeDropdown/index.js